import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import Logo from '../images/shop_logo.png';
import '../styles/Nav.css';
import {SHOP_MOTTO } from '../Variables.js';

const pages = [
  { name: "personal information", icon: "user", link: "personal-information" },
  { name: "change password", icon: "lock", link: "change-password" },
];

const Nav = () => {
  const { logOut, userData } = useUserAuth();
  const navigate = useNavigate();
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const sidePanelRef = useRef(null);

  const handleHamburgerClick = () => {
    setIsSidePanelOpen(!isSidePanelOpen);
  };

  const handleClickOutside = (event) => {
    if (sidePanelRef.current && !sidePanelRef.current.contains(event.target)) {
      setIsSidePanelOpen(false);
    }
  };

  useEffect(() => {
    if (isSidePanelOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.body.classList.add("no-scroll");
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.classList.remove("no-scroll");
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.classList.remove("no-scroll");
    };
  }, [isSidePanelOpen]);

  const handleLogout = async () => {
    try {
      await logOut();
      navigate("/");
    } catch (error) {
      // console.log(error.message);
    }
  };

  // Check if user is inactive Teacher/Parent
  const isInactiveTeacherOrParent = userData && 
    (userData.status === "Teacher" || userData.status === "Parent") && 
    userData.isActive === false;

  return (
    <>
      {!isSidePanelOpen && <div className='nav-back'></div>}
      <div className="home-icons justify-center align-center">
        {!isInactiveTeacherOrParent && (
          <button onClick={handleHamburgerClick}>
            <i className="fa-solid fa-bars size3 plain-button"></i>
          </button>
        )}
        <div className='profile-name align-center justify-center'>
          {userData ? (
            isInactiveTeacherOrParent ? (
              <span className="nav-name">You can not use this app, {userData.firstName}</span>
            ) : (
              <span className="nav-name">Hi, {userData.firstName}</span>
            )
          ) : (
            <Link to="/login" className="nav-signin-link font-gold">SIGN IN</Link>
          )}
        </div>        
        {userData && !isInactiveTeacherOrParent && (
          <span className="nav-logo-name font-gold">{userData.status}</span>
        )}
      </div>

      {!isInactiveTeacherOrParent && (
        <div ref={sidePanelRef} className={`side-panel ${isSidePanelOpen ? "open" : ""}`}>
          <button onClick={handleHamburgerClick} className="plain-button close-button">
            <i className="fa-solid fa-angle-left size3 font-light-blue-cash"></i>
          </button>
          <div className='column align-center jsutify-center'>
            <img src={Logo} className="middle-logo" alt="logo" />          
          </div>
          <div>
            <div className="column categories-div">
              {pages.map((page, index) => (
                <Link
                  key={index}
                  to={`/${page.link}`}
                  className="row align-center space-between first-cover"
                >
                  &nbsp;<i className={`fa-solid fa-${page.icon} font-light-blue-cash`}></i><p className="second">{page.name}</p>
                </Link>
              ))}
              <Link
                  to={`/`}
                  className="row align-center space-between first-cover"
                >
                  &nbsp;<i className='fa-solid fa-house font-light-blue-cash'></i><p className="second">Home</p>
                </Link>
                <Link
                  onClick={() => window.location.reload()}
                  className="row align-center space-between first-cover"
                >
                  &nbsp;<i className='fa-solid fa-rotate-right font-light-blue-cash'></i><p className="second">Reload Page</p>
                </Link>
                <Link
                  onClick={handleLogout}
                  className="row align-center space-between first-cover"
                >
                  &nbsp;<i className='fa-solid fa-power-off font-teal'></i><p className="second">Logout</p>
                </Link>
            </div>
          </div>
          <div className="panel-items column">
            <div className='row align-center socials'>            
              <a href="tel:+2347036313352" target='_blank' rel="noreferrer" className='row align-center justify-center social'><i className="fa-solid fa-phone font-light-blue-cash"></i></a>
              <a href="https://wa.me/+2347036313352" target='_blank' rel="noreferrer" className='row align-center justify-center social'><i className="fa-brands fa-whatsapp font-light-blue-cash"></i></a>
              <a href="mailto:deroyale.dev@gmail.com" target='_blank' rel="noreferrer" className='row align-center justify-center social'><i className="fa-solid fa-envelope font-light-blue-cash"></i></a>
              <a href="https://deroyale.com.ng" target='_blank' rel="noreferrer" className='row align-center justify-center social'><i className="fa-solid fa-globe font-light-blue-cash"></i></a>
            </div>
            <div className='row align-center socials'>            
              {userData && <>              
                {userData && userData.admin === "True" ? (<Link to="/admin" className="row align-center justify-center social"><i className="fa-solid fa-person size3"></i></Link>) : null}
              </>}
            </div>
          </div>
          <p className="halal-text">{SHOP_MOTTO}</p>
        </div>
      )}
    </>
  );
};

export default Nav;